<template>
  <mds-modal
    size="large"
    :width="'1200px'"
    aria-label="Large Modal"
    v-model="isopenModel"
    title=""
    action-required
  >
    <tool-advance-filter
      :filterInfo="filterInfo"
      :filterOptions="filterOptions"
      @onFilterSelected="onFilterSelected"
      @buttonclick="genericMethodClick"
    >
      <template #dynamic-content v-if="selectedComponent != ''">
        <component
          ref="filtercontent"
          :is="selectedComponent"
          :baselineData="baselineFilterObject"
          @resetBaselineData="resetBaselineData"
          @openErrorTab="openErrorTab"
          :showTableView="showTable"
          :tableViewSettings="tableSetting"
        ></component>
      </template>
    </tool-advance-filter>
  </mds-modal>
</template>
<script>
import { ToolAdvanceFilter } from "../../component/tool";
import MdsModal from "@mds/modal";
import LoanInterestRateFilter from "./loan-interest-rate-filter.vue";
import LoanDrawdownFilter from "./loan-drawdown-filter.vue";
import LoanTermFilter from "./loan-term-filter.vue";
import LoanRepaymentFilter from "./loan-repayment-filter.vue";
import {
  AdvanceFilter,
  AdvanceFilterComponetName,
} from "../../helpers/constant";

export default {
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    isopenModel: {
      type: Boolean,
    },
    baselineData: {
      type: Object,
    },
    openTabName: {
      type: String,
    },
  },
  components: {
    ToolAdvanceFilter,
    LoanInterestRateFilter,
    LoanDrawdownFilter,
    LoanTermFilter,
    LoanRepaymentFilter,
    MdsModal,
  },
  data() {
    return {
      selectedValue:
        this.openTabName == AdvanceFilterComponetName.Interest_Rate
          ? AdvanceFilter.Interest_Rate
          : this.openTabName == AdvanceFilterComponetName.Repayment
          ? AdvanceFilter.Repayment
          : this.openTabName == AdvanceFilterComponetName.DrawDown
          ? AdvanceFilter.DrawDown
          : this.openTabName == AdvanceFilterComponetName.LoanTerm
          ? AdvanceFilter.LoanTerm
          : 0,
      baselineFilterObject: Object.assign({}, this.baselineData),
      tableSetting: this.tableViewSettings,
      showTable: this.showTableView,
      selectedComponent: this.openTabName,
      filterInfo: {
        title: "Advanced Setting",
        borderPosition: "bottom",
        actionButtons: [
          {
            method: "closeAdvancedFilter",
            variation: "secondary",
            text: "Cancel",
            id: "loanAdvancedFilter_2",
          },
          {
            method: "applyAdvancedSetting",
            variation: "primary",
            text: "Apply Changes",
            id: "loanAdvancedFilter_1",
          },
        ],
      },
    };
  },
  mounted() {},

  computed: {
    filterOptions() {
      let selectedOption = this.selectedValue;
      return [
        {
          id: "filterOption_1",
          active: selectedOption == 1,
          text: "Interest Rate",
          value: AdvanceFilter.Interest_Rate,
        },
        {
          id: "filterOption_2",
          active: selectedOption == 2,
          text: "Repayment",
          value: AdvanceFilter.Repayment,
        },
        {
          id: "filterOption_3",
          active: selectedOption == 3,
          text: "Drawdown",
          value: AdvanceFilter.DrawDown,
        },
        {
          id: "filterOption_4",
          active: selectedOption == 4,
          text: "Loan Term",
          value: AdvanceFilter.LoanTerm,
        },
      ];
    },
  },

  async created() {},
  methods: {
    openErrorTab(tabId) {
      this.selectedValue = tabId;
      this.openTab();
    },
    resetBaselineData(changedBaselineObject) {
      this.baselineFilterObject = changedBaselineObject;
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    async applyAdvancedSetting() {
      this.$refs.filtercontent.fillLoanModel(this.selectedValue);
      let iserrorPresentInCurrentTab = this.$refs.filtercontent.validations(
        this.baselineFilterObject.advancedetails,
        this.selectedValue
      );
      if (iserrorPresentInCurrentTab) {
        return;
      }
      let isErrorPresent =
        this.$refs.filtercontent.IsAnyLoanOptionHaveInvalidData(
          this.baselineFilterObject.Errors
        );
      if (isErrorPresent) {
        return;
      }
      if (
        this.baselineFilterObject.Errors.InterestRate.length == 0 &&
        this.baselineFilterObject.Errors.Drawdown.length == 0 &&
        this.baselineFilterObject.Errors.Repayment.length == 0 &&
        this.baselineFilterObject.Errors.LoanTerm.length == 0
      ) {
        await this.$refs.filtercontent.UpdateGraph();
        this.$emit("saveData", this.baselineFilterObject);
      }
    },
    closeAdvancedFilter() {
      this.selectedValue = AdvanceFilter.Interest_Rate;
      this.selectedComponent = AdvanceFilterComponetName.Interest_Rate;
      this.$emit("closeModel");
    },
    openTab() {
      if (this.selectedValue == AdvanceFilter.Interest_Rate) {
        this.selectedComponent = AdvanceFilterComponetName.Interest_Rate;
      } else if (this.selectedValue == AdvanceFilter.Repayment) {
        this.selectedComponent = AdvanceFilterComponetName.Repayment;
      } else if (this.selectedValue == AdvanceFilter.DrawDown) {
        this.selectedComponent = AdvanceFilterComponetName.DrawDown;
      } else if (this.selectedValue == AdvanceFilter.LoanTerm) {
        this.selectedComponent = AdvanceFilterComponetName.LoanTerm;
      }
    },
    onFilterSelected(filterOption) {
      this.$refs.filtercontent.fillLoanModel(this.selectedValue);
      this.selectedValue = filterOption.value;
      this.openTab();
    },
  },
};
</script>
<style lang="scss" module></style>
